import React from 'react';

import { cssMap } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import ProjectCardImage from '../assets/ProductCardImage.png';

import { messages } from './messages';

const styles = cssMap({
	container: {
		paddingTop: token('space.400'),
		paddingRight: token('space.400'),
		paddingBottom: token('space.400'),
		paddingLeft: token('space.400'),
		width: '360px',
	},
	projectCardImage: {
		display: 'flex',
		width: '220px',
		maxHeight: '160px',
	},
});

type EmptyStateProps = {
	heading?: string;
	description: string;
	buttonLabel?: string;
	onClick?: () => void;
};

export const EmptyState = ({ heading, description, buttonLabel, onClick }: EmptyStateProps) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container}>
			<Stack space="space.300" alignInline="center">
				<Box xcss={styles.projectCardImage}>
					<Image src={ProjectCardImage} alt="" />
				</Box>
				<Heading size="small">
					{heading || formatMessage(messages.genericEmptyStateHeading)}
				</Heading>
				<Text color="color.text.subtle" align="center" size="medium">
					{description}
				</Text>
				<Button appearance="primary" onClick={onClick}>
					{buttonLabel || formatMessage(messages.createProjectButtonLabel)}
				</Button>
			</Stack>
		</Box>
	);
};
